<template>
  <div class="basket-product">
    <img v-if="product.prodImgSrc" class="product-image"
      :src="product.prodImgSrc"
      :alt="product.prodName"
      loading="lazy"
    />

    <div class="d-flex flex-column w-100">
      <!-- Product Details -->
      <div class="product-info">
        <span class="product-text">
          {{ product.prodText }}<template v-if="product.optionText"> ({{ cleanedProdOptionText(product.optionText) }})</template>
        </span>
      </div>
      <!-- todo : Append Product Details if any here (example Burger Menu: Selected Desert and Drink) -->

      <div class="d-flex flex-row justify-content-end">
        <!-- todo translate -->
        <SpinButton
          @click.stop
          v-if="editable && !product.isAutoItem"
          :min="0"
          :max="max"
          :modelValue="product.quantity"
          @update:modelValue="({ value }) => onProductQuantityChange(value)"
          role="button"
          tabindex="0"
          aria-label="Add or remove product from basket"
        />
        <span v-else class="product-quantity-label" aria-label="Quantity">{{ product.quantity }}x</span>

        <!-- Product Price -->
        <!-- todo translate aria-label -->
        <span class="product-price" aria-label="Price">{{ product.formattedTotalPrice }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import SpinButton from "@/components/page-components/templates/SpinButton.vue";
import { cleanedProdOptionText } from "@/utils/productUtils";

export default {
  components: {SpinButton},
  props: {
    product: {
      type: Object,
      required: true,
    },
    max: {
      type: Number,
      required: false
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cleanedProdOptionText,
    onProductQuantityChange(value) {
      this.$emit('product-quantity-change', this.product.id, value);
    },
  },
};
</script>

<style scoped>
.basket-product {
  display: flex;
  align-items: stretch;
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
  gap: 12px;
}

.product-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}

.product-info {
  flex-grow: 1;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.product-price {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  min-width: 80px;
  text-align: right;
}

.product-quantity-label {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  min-width: 40px;
  text-align: right;
  margin: 0 8px;
}
</style>
